export const table = {
  empty: 'Tabel kehilangan data',
  empty_db: `<span class="block text-center">Tidak ada data di meja.</span>`,
  create_db: `Buat db`,
  overview: 'Gambaran',
  actions: 'Tindakan',
  show: 'Tunjukkan',
  records: 'rekam',
  paginate_info: 'Menampilkan {start} ke {end} semua {all} postingan',
  loading: 'Mohon menunggu, Kami sedang memproses data',
  error: 'Proses data error',
  last_date: 'Di bagian ini, statistik tersedia hingga ',
  need_select_filter: 'Untuk melihat daftar nomor yang tersedia - pilih negara',

  field: {
    id: 'ID',
    name: 'Nama',
    naming: 'Nama',
    title: 'Judul',
    time_zone: 'Zone waktu',
    status: 'Status',
    type: 'Type',
    info: 'Informasi',
    created_at: 'Dibuat pada',
    updated_at: 'Diperbaharui pada'
  },

  action: {
    edit: 'Sunting',
    change: 'Edit',
    rename: 'Rename',
    duplicate: 'duplicate',
    delete: 'Menghapus',
    show: 'Show',
    hide: 'Hide',
    add_ip: 'Tambahkan IP'
  }
};
